import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setAccountStatisticsData, setLoadAccountStatisticsData } from 'store/models/accountStatistics';
import { addNotification } from 'store/models/notification';

export default () => {
    return (dispatch, getState) => {
        const { from, to, accountId } = getState().accountStatistics;
        dispatch(setLoadAccountStatisticsData(true));
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        });
        if (!accountId) {
            return dispatch([
                setLoadAccountStatisticsData(false),
                addNotification(NotificationName.AccountStatisticsNotAccountId),
            ]);
        }
        return fetcher
            .get(`/api/v1/statistics/account/${accountId}?${queryStr}`)
            .then((data) => {
                dispatch([setAccountStatisticsData(data), setLoadAccountStatisticsData(false)]);
            })
            .catch(() => {
                dispatch([setAccountStatisticsData([]), setLoadAccountStatisticsData(false)]);
            });
    };
};
